import React from 'react';
import { NavLink } from 'react-router-dom';
import './Navbar.css';

function Navbar() {
  return (
    <nav className="navbar">
      <NavLink to="/" end className={({ isActive }) => isActive ? 'active' : ''}>Rhyme Generator</NavLink>
      <NavLink to="/word-generator" className={({ isActive }) => isActive ? 'active' : ''}>Word Generator</NavLink>
    </nav>
  );
}

export default Navbar;
